<template>
	<div
		class="rounded-lg data-table mt-4"
		v-if="Object.values(dataHeaders).length > 0"
	>
		<div
			class="d-flex justify-space-between align-center pa-2 white--text width-full"
		>
			<div
				v-for="(header, idx) in Object.values(dataHeaders)"
				:key="idx"
				class="d-flex"
				@click="() => changeSorting(idx)"
				:style="`width:${100 / Object.values(dataHeaders).length}%`"
			>
				<span
					>{{ header
					}}<span
						class="op-8"
						v-if="salaryStructureSorting.col === idx"
						>{{
							!salaryStructureSorting.desc ? "&#8593;" : "&#8595;"
						}}</span
					></span
				>
			</div>
		</div>
		<div
			:style="
				`overflow-y: auto; max-height: ${
					isJeet11Executive ? '25vh' : '40vh'
				}`
			"
		>
			<div
				v-for="(item, i) in salaryStructureData"
				:key="i"
				class="d-flex justify-space-between align-center pa-2"
				:style="highlightIndex === i ? 'background: #A4F0E2' : ''"
			>
				<div
					v-for="(key, idx) in Object.keys(dataHeaders)"
					:key="idx"
					:style="`width:${100 / Object.values(dataHeaders).length}%`"
				>
					{{ item[key] }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from "vuex";
import { CHANGE_SALARY_STRUCTURE_SORTING } from "../../store/action-types";
export default {
	name: "TargetDetailsTable",
	props: ["salaryData", "dataHeaders", "highlightIndex", "isJeet11Executive"],
	data() {
		return {
			salaryStructureData: []
		};
	},
	methods: {
		sortTable() {
			const { col = -1, desc = false } = this.salaryStructureSorting;
			const headers = Object.keys(this.dataHeaders);
			const sortByKey = headers[col];
			this.salaryStructureData.sort((a, b) =>
				desc ? a[sortByKey] - b[sortByKey] : b[sortByKey] - a[sortByKey]
			);
		},
		changeSorting(index) {
			this.$store.dispatch(CHANGE_SALARY_STRUCTURE_SORTING.dispatch, {
				col: index,
				desc:
					this.salaryStructureSorting.col === index
						? !this.salaryStructureSorting.desc
						: true
			});
		}
	},
	computed: {
		...mapState({
			salaryStructureSorting: state => state.common.salaryStructureSorting
		})
	},
	watch: {
		salaryData() {
			this.salaryStructureData = this.salaryData;
		},
		salaryStructureSorting() {
			this.sortTable();
		}
	}
};
</script>
<style scoped>
.data-table > div:nth-child(odd) {
	background: #e7eaf9;
}
.data-table > div:nth-child(even) {
	background: rgba(195, 218, 254, 0.2);
}
.data-table > div:first-child {
	background: #2d4970;
	border-radius: 8px 8px 0 0;
}
.data-table > div:last-child {
	border-radius: 0 0 8px 8px;
}
</style>
